function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExpensifyCardIcon = function SvgExpensifyCardIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M1.75 3A1.75 1.75 0 0 0 0 4.75v10.5C0 16.216.784 17 1.75 17h16.5A1.75 1.75 0 0 0 20 15.25V4.75A1.75 1.75 0 0 0 18.25 3H1.75Zm11.249 11.5H7v-9h5.999v2H9V9h3v1.909H9v1.592h4V14.5Z",
    style: {
      fillRule: "evenodd"
    }
  }));
};
export default SvgExpensifyCardIcon;